<template>
  <v-dialog-old ref="dialog" id="deleteDialog">
    <fieldset width="400">
      <legend>Удаление врача</legend>
        <ValidationObserver ref="doctorDeleteForm">
          <form>
            <table class="grid">
              <tr>
                <td width="100%">
                  <label>Причина удаления</label>

                  <select v-model="reason" class="large" required>
                    <option value=""></option>
                    <template v-for="reason in deletionReasons">
                      <option :value="reason.code" >{{reason.name}}</option>
                    </template>

                  </select>
                </td>
              </tr>
              <tr>
                <td width="100%">
                  <label>Комментарий</label>
                    <ValidationProvider :rules="{required: reason === 'other'}" v-slot="{ errors }">

                        <textarea
                            v-model="comment"
                            :required="reason === 'other'"

                            :class="{'hasError' : errors[0]}"
                            v-tooltip="{
                               content: !errors[0] ? '' : `Поле 'Комментарий' обязательно для заполнения при выборе причины удаления 'Другое'`,
                               template: $errTemplate,
                            }"
                        ></textarea>
                    </ValidationProvider>
                </td>
              </tr>
            </table>
          </form>
        </ValidationObserver>
    </fieldset>
    <footer>
      <v-loading-component  @click="deleteDoctor">
        <template slot-scope="{ loadingClass }">
          <button :class="['red', loadingClass]">Удалить</button>
        </template>
      </v-loading-component>
    </footer>
  </v-dialog-old>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    doctor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      comment: '',
      reason: ''
    }
  },
  computed: {
    ...mapState({
      deletionReasons: state => state.dictionary.deletionReasonsOptions
    }),
  },
  methods: {
    deleteDoctor(btn) {
        btn.startLoadingAnimation();
        this.$refs.doctorDeleteForm.validate().then(success => {
            if (!success) {
                const el = document.querySelector(".hasError:first-of-type");
                el.scrollIntoView({behavior: "smooth"});
                btn.stopLoadingAnimation()
                return;
            }

            return this.axios.post('doctors/delete/' + this.doctor.id, {...this.doctor, comment: this.comment, reason: this.reason }).then(() => {
                btn.stopLoadingAnimation()
                this.$refs.dialog.hide();
                this.$emit('deleted')
            }).catch((error) => {
            });
        })
    }
  },
}
</script>

<style lang="scss">
#deleteDialog {
  width: 505px !important;
}
#deleteDialog .multiselect__single {
  padding-top: 5px !important;
}
#deleteDialog .multiselect__select {
  height: 32px !important;
}
#deleteDialog .multiselect__tags {
  height: 32px!important;
}
#deleteDialog {
  overflow: visible !important;
}
</style>
